import Vue from 'vue'

import '~/config'

import store from './store'
import router from './router'
import vuetify from './plugins/vuetify'
import i18n from '~/plugins/i18n'
import App from './App.vue'

import '~/plugins'
import '~/components'

Vue.config.productionTip = false
// i18n.silentTranslationWarn = true

const ignoreWarnMessage = 'The .native modifier for v-on is only valid on components but it was used on <div>.'
// eslint-disable-next-line no-unused-vars
Vue.config.warnHandler = function(msg, vm, trace) {
	// `trace` is the component hierarchy trace
	if (msg === ignoreWarnMessage && vm.$options.name === 'v-calendar-daily') {
		msg = null
		// vm = null
		// trace = null
	}
}

/* new Vue({
	router,
	store,
	vuetify,
	render: h => h(App)
}).$mount('#app') */

new Vue({
	i18n,
	router,
	store,
	vuetify,
	...App
})
